import {
	Component,
	Input,
	OnChanges,
	SimpleChanges
} from '@angular/core';

import { HlsUtilService } from './HlsUtil.Service';

import styles from './VbNoSupportedPlaybacks.module.less'; // shared

@Component({
	selector: 'vb-playback-unavailable',
	host: {
		'[class]': 'styles.root + " " + (isSmallSizePlayer ? styles.smallSizePlayer : "")'
	},
	template: `
		<span [ngClass]="styles.warningSign" class="glyphicons white circle_exclamation_mark"></span>
		<span [hidden]="isRevConnectMeshFull">
			{{ translations.playbackNotAvailable }}
		</span>
		<span
			[hidden]="!isRevConnectMeshFull">
			{{ translations.revConnectMeshFull }}
		</span>
	`
})
export class VbPlaybackUnavailableComponent implements OnChanges {
	@Input() public mediaError: any;
	@Input() public translations: { [key: string]: string };
	@Input() public isSmallSizePlayer: boolean;

	public isRevConnectMeshFull: boolean;
	public readonly styles = styles;

	constructor(
		private HlsUtilService: HlsUtilService
	) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.mediaError) {
			this.isRevConnectMeshFull = this.HlsUtilService.isRevConnectMeshFullError(this.mediaError);
		}
	}
}
